import { Box, Flex, Heading, Container } from '@chakra-ui/react'
import { useDeviceType } from 'app/hooks'
import PospFooter from 'Components/PospFooter'
import { PospHeader } from 'Components/PospHeader'
import Stepper, { MobileStepper } from 'Components/Stepper'
import { USER_REGISTRATION_TYPE } from 'Constants'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
// { children }: { children: React.ReactNode }

interface Iprops {
  HeaderComponent: JSX.Element
  children: React.ReactNode
}
const Layout = (props: Iprops) => {
  const store = useSelector((state: any) => state.user)
  const { userState, activeKey, isLoggedIn, isRegistered } = store

  // console.log('activeKey: ', activeKey)
  const { HeaderComponent, children } = props
  const navigate = useNavigate()
  const { isMobile } = useDeviceType()
  const [stepperValues, setStepperValues] = useState<any>([
    {
      key: 'pan_iib_verification',
      title: 'PAN Verification',
    },
    {
      key: 'personal_details',
      title: 'Personal Details',
    },
    {
      key: 'doc_upload',
      title: 'Document Upload',
    },
    {
      key: 'training_module',
      title: 'Training Module',
    },
    {
      key: 'general_insu_exam',
      title: 'Examination',
    },
  ])

  // const ifRegisteredStepperValues = [
  //   {
  //     key: 'pan_iib_verification',
  //     title: 'PAN Verification',
  //   },
  //   {
  //     key: 'personal_details',
  //     title: 'Personal Details',
  //   },
  //   {
  //     key: 'doc_upload',
  //     title: 'Document Upload',
  //   },
  // ]
  // const allStepperValues = [
  //   {
  //     key: 'pan_iib_verification',
  //     title: 'PAN Verification',
  //   },
  //   {
  //     key: 'personal_details',
  //     title: 'Personal Details',
  //   },
  //   {
  //     key: 'doc_upload',
  //     title: 'Document Upload',
  //   },
  //   {
  //     key: 'training_module',
  //     title: 'Training Module',
  //   },
  //   {
  //     key: 'general_insu_exam',
  //     title: 'Examination',
  //   },
  // ]
  const mobileStepperValues = [
    {
      key: 'pan_iib_verification',
      title: 'PAN Check',
    },
    {
      key: 'personal_details',
      title: 'Personal Details',
    },
    {
      key: 'doc_upload',
      title: 'Documents',
    },
    {
      key: 'training_module',
      title: 'Training',
    },
    {
      key: 'general_insu_exam',
      title: 'Exam',
    },
  ]

  // useEffect(() => {
  //   if (isRegistered === USER_REGISTRATION_TYPE.registered) {
  //     setStepperValues(allStepperValues)
  //   } else if (isRegistered === USER_REGISTRATION_TYPE.notRegistered) {
  //     setStepperValues(allStepperValues)
  //   }
  // }, [isRegistered])

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/')
    }
  }, [])

  // const activeStep = 2;
  return (
    <Box background='#F6F6F6 0% 0% no-repeat padding-box' w='full' minH='100vh'>
      <PospHeader />
      {isMobile ? (
        <Container>
          <Flex
            w='98%'
            margin='0 auto'
            overflowX={'scroll'}
            h='90%'
            marginTop='5'
            direction='column'
            justifyContent='space-between'
          >
            <Box width='full'>
              <Flex
                flexDirection='row'
                overflow='hidden'
                borderRadius='10px'
                w='100%'
                bg='white'
                h='full'
                alignItems='center'
              >
                {mobileStepperValues?.map((val: any, ind: number) => (
                  <Box minW='70px' w='100%' key={ind}>
                    <MobileStepper
                      isActive={val.key === activeKey}
                      isCompleated={userState[val.key].status === 'COMPLETE'}
                      stepName={val.title}
                      showAfter={!(ind === stepperValues.length - 1)}
                    />
                  </Box>
                ))}
              </Flex>
            </Box>
            <Box
              w='full'
              pb={5}
              mt='5'
              border='1px solid #D8D8D8'
              background='#fff 0% 0% no-repeat padding-box'
              borderRadius={10}
              overflowY='scroll'
            >
              <Box boxShadow='0px 2px 4px #00000029'>{HeaderComponent}</Box>
              {children}
            </Box>
          </Flex>
        </Container>
      ) : (
        <>
          <Heading mt={4} paddingLeft='18%'>
            POSP Registration
          </Heading>
          <Flex w='95%' overflowX={'scroll'} h='90%' marginTop='10' justifyContent='space-between'>
            <Box width='20%'>
              <Flex flexDirection='column' alignItems='center'>
                {stepperValues?.map((val: any, ind: number) => (
                  <div key={ind} style={{ marginBottom: '30px' }}>
                    <Stepper
                      isActive={val.key === activeKey}
                      isCompleated={userState[val.key].status === 'COMPLETE'}
                      stepName={val.title}
                      showAfter={!(ind === stepperValues.length - 1)}
                    />
                  </div>
                ))}
              </Flex>
            </Box>
            <Box
              w='80%'
              pb={5}
              border='1px solid #D8D8D8'
              background='#fff 0% 0% no-repeat padding-box'
              borderRadius={10}
              overflowY='scroll'
            >
              <Box boxShadow='0px 2px 4px #00000029'>{HeaderComponent}</Box>
              {children}
            </Box>
          </Flex>
        </>
      )}
      <PospFooter />
    </Box>
  )
}

export default Layout
